import { create } from 'zustand';

// Define types for the store
type BlockSupportStore = {
  disallowed: string[];
  dynamic: string[];
  allowed_dynamic: string[];
  setDisAllowed: (disallowed: string[]) => void;
  setDynamic: (dynamic: string[]) => void;
  setAllowedDynamic: (allowed_dynamic: string[]) => void;
};

// Create the store
export const useBlockSupportStore = create<BlockSupportStore>((set) => ({
  disallowed: [],
  dynamic: [],
  allowed_dynamic: [],
  setDisAllowed: (disallowed: string[]) => set({ disallowed: disallowed }),
  setDynamic: (dynamic: string[]) => set({ dynamic: dynamic }),
  setAllowedDynamic: (allowed_dynamic: string[]) =>
    set({ allowed_dynamic: allowed_dynamic }),
}));
